module.exports = __webpack_public_path__ + "static/img/btn-appoint2.7475223.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/home/pc/btn-appoint2.png
// module id = mCMc
// module chunks = 7